import axios, {Axios} from "axios";

export interface GramSessionData {
  accountId: string;
  workerId: string;
  workerNicename: string;
  session: string;
  telegramId: string;
  revoked: boolean;
}

interface InitResponse {
  result: GramSessionData;
}

const baseUrl = 'https://dev.slaver.vip/api/zchat';

class AuthController {
  private axiosInstance: Axios;

  constructor() {
    this.axiosInstance = axios.create({
      headers: {
        'Accept': 'application/json',
      }
    });
  }

  async init(sessionId: string): Promise<GramSessionData> {
    const response = await this.axiosInstance.request<InitResponse>({
      method: 'GET',
      url: `${baseUrl}/init?id=${sessionId}`,
    });

    if (response.status > 299) {
      throw new Error('Something wrong');
    }

    return response.data.result;
  }

  async sync(sessionId: string): Promise<string | true> {
    const response = await this.axiosInstance.request<{result: string | true}>({
      method: 'GET',
      url: `${baseUrl}/sync?id=${sessionId}`,
    });

    if (response.status > 299) {
      throw new Error('Something wrong');
    }

    return response.data.result;
  }
}

function getAuthController() {
  return new AuthController();
}

export default getAuthController;
